module.exports = __webpack_public_path__ + "static/media/zipcodes_centers.bb6d5fd9.geojson";